export const configTypePolicy = (
  keyArgs: false | string[] | Array<string | Array<string>> | undefined,
  limitTrigger: number
) => ({
  keyArgs,
  // eslint-disable-next-line default-param-last
  merge(existing = {}, incoming, { args }) {
    const mergedData = existing['data'] ? existing['data'].slice(0) : [];
    if (args?.args && (args.args.limit > limitTrigger || args.args.offset === 0)) {
      return { ...incoming, data: [...incoming.data] };
    }

    return { ...incoming, data: [...mergedData, ...incoming.data] };
  },
  read(existing: {}, { args }) {
    return existing;
  }
});
